import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-remote",
  "use": "icon-leo-remote-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-remote\">\r\n<g transform=\"translate(-176.128 -283.648) scale(1.344000)\">\r\n<path d=\"M320 576a192 192 0 0 1 384 0h-64a128 128 0 0 0-256 0H320z\" />\r\n  <path d=\"M384 672a128 128 0 0 1 256 0h-64a64 64 0 0 0-128 0h-64z\" />\r\n  <path d=\"M480 768h64v96h-64v-96zM192 320h640v64H192v-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-remote.svg
// module id = uji8
// module chunks = 478